const access = {
  getMyAccess: { method: "GET", path: "/access/my" },
  checkAccess: (contentType, contentId) => ({
    method: "GET",
    path: `/access/check/${contentType}/${contentId}`,
  }),
  updatePricing: (contentType, contentId) => ({
    method: "PATCH",
    path: `/access/${contentType}/${contentId}/pricing`,
  }),
  grantAccess: { method: "POST", path: "/access/grant" },
  revokeAccess: { method: "DELETE", path: "/access/revoke" },
  getAllAccess: { method: "GET", path: "/access" },
  getContentAccess: (contentType, contentId) => ({
    method: "GET",
    path: `/access/${contentType}/${contentId}/users`,
  }),
  getUserAccess: (userId) => ({
    method: "GET",
    path: `/access/users/${userId}`,
  }),
};

export default access;
